var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5773 49.5387L31.9875 38.0516C31.3985 37.6547 30.6278 37.6547 30.0387 38.0516C29.4595 38.4327 29.1425 39.106 29.2181 39.7953V62.7697C29.1425 63.4588 29.4593 64.1324 30.0387 64.5134L30.9617 64.821C31.3275 64.8285 31.6863 64.7209 31.9873 64.5134L51.5771 53.0263C52.54 52.5457 52.931 51.3753 52.4503 50.4123C52.2618 50.0339 51.9552 49.7274 51.5773 49.5387ZM33.3208 59.1797V43.3849L46.7568 51.2824L33.3208 59.1797Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2693 22.0513H9.73069C4.63261 22.0513 0.5 26.1841 0.5 31.282V70.2564C0.5 75.3545 4.63281 79.4871 9.73069 79.4871H71.2693C76.3674 79.4871 80.5 75.3543 80.5 70.2564V31.282C80.5 26.1839 76.3672 22.0513 71.2693 22.0513ZM76.3974 70.2564C76.3974 73.0886 74.1015 75.3845 71.2693 75.3845H9.73069C6.89847 75.3845 4.60257 73.0886 4.60257 70.2564V31.282C4.60257 28.4497 6.89847 26.1538 9.73069 26.1538H71.2693C74.1015 26.1538 76.3974 28.4497 76.3974 31.282V70.2564Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.064 15.8975H70.0383C71.1713 15.8975 72.0896 14.9791 72.0896 13.8462C72.0896 12.7133 71.1713 11.7949 70.0383 11.7949H11.064C9.93105 11.7949 9.0127 12.7133 9.0127 13.8462C9.0127 14.9791 9.93105 15.8975 11.064 15.8975Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7818 4.61527H61.2178C62.3507 4.61527 63.2691 3.69691 63.2691 2.56398C63.2691 1.43105 62.3507 0.512695 61.2178 0.512695H19.7818C18.6488 0.512695 17.7305 1.43105 17.7305 2.56398C17.7305 3.69691 18.649 4.61527 19.7818 4.61527Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.60fc7509.svg";
export { ForwardRef as ReactComponent };